import { type CompanyDto } from '@/app/models/CompanyDto';
import { type CompanyFilter } from '@/app/models/filters/CompanyFilter';

export const companyFilterFor = (companies: CompanyDto[]): CompanyFilter => ({
  company_ids: companies.map((company) => company.id ?? ''),
  company_labels: companies.map((company) => company.fantasy_name || company.social_name || ''),
});

export const companiesInFilter = ({ company_ids = [], company_labels = [] }: CompanyFilter): CompanyDto[] =>
  company_ids.map((id, index) => ({ id, fantasy_name: company_labels[index] }));
